import { render, staticRenderFns } from "./clients-search.vue?vue&type=template&id=1fb2c2ab&scoped=true"
import script from "./clients-search.vue?vue&type=script&lang=js"
export * from "./clients-search.vue?vue&type=script&lang=js"
import style0 from "./clients-search.vue?vue&type=style&index=0&id=1fb2c2ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2c2ab",
  null
  
)

export default component.exports